import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Drawer, AppBar, Toolbar, CssBaseline, IconButton, Hidden, Menu, withWidth } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import DrawerItems from './drawerItems';
import SigniantHeaderLogo from './headerLogo';
import RightLinks from '../RightLinks';
const drawerWidth = 270;

const styles = (theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    drawer: {
        marginTop: '30px',
        borderRight: '1px solid rgba(0, 0, 0, 0.12)',
        [theme.breakpoints.up('lg')]: {
            width: drawerWidth,
            flexShrink: 0,
            zIndex: 56,
        },
    },
    appBar: {
        marginLeft: drawerWidth,
        boxShadow: 'none',
        [theme.breakpoints.up('md')]: {
            width: '100%',
            zIndex: 100,
        },
        height: '78px',
        fontSize: '1rem',
    },
    menuButton: {
        marginTop: '1rem',
        marginRight: 5,
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        display: 'contents',
        [theme.breakpoints.down('md')]: {
            display: 'inherit',
        },
        width: drawerWidth,
        zIndex: 56,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 3,
    },
});

class ResponsiveDrawer extends React.Component {
    state = {
        mobileOpen: false,
        searchOpen: false,
    };

    handleDrawerToggle = () => {
        this.setState((state) => ({ mobileOpen: !state.mobileOpen }));
    };

    handleSearchToggle = () => {
        this.setState((state) => ({ searchOpen: !state.searchOpen }));
    };

    render() {
        const { classes, theme, width, container } = this.props;

        //provides a product name by looking at the current path
        const getSelectedProduct = (fullPath) => {
            let path = fullPath;
            if (path.startsWith('/')) {
                path = path.substring(1);
            }
            // TODO pls don't?
            if (path === 'search' || path === 'search/') {
                return null;
            }
            let product = path.split('/');

            return product[0];
        };

        const drawer = (
            <div>
                <div className={classes.toolbar} />
                <Hidden lgUp implementation="css">
                    <DrawerItems
                        handleDrawerToggle={this.handleDrawerToggle}
                        selectedProduct={getSelectedProduct(location.pathname)}
                    />
                </Hidden>
                <Hidden mdDown implementation="css">
                    <DrawerItems selectedProduct={getSelectedProduct(location.pathname)} />
                </Hidden>
            </div>
        );

        return (
            <div className={classes.root}>
                <CssBaseline />
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="Open drawer"
                            onClick={this.handleDrawerToggle}
                            className={classes.menuButton}
                        >
                            <MenuIcon />
                        </IconButton>

                        {!this.state.searchOpen && (
                            <SigniantHeaderLogo selectedProduct={getSelectedProduct(location.pathname)} />
                        )}
                        <RightLinks
                            selectedProduct={getSelectedProduct(location.pathname)}
                            className={classes.rightLinks}
                            searchOpen={this.state.searchOpen}
                            handleSearchToggle={this.handleSearchToggle}
                        />
                    </Toolbar>
                </AppBar>

                {
                    //ternary expression, if product name is not null return side-menu else return null
                    getSelectedProduct(location.pathname) || width === 'sm' || width === 'xs' || width === 'md' ? (
                        <nav className={classes.drawer}>
                            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                            <Hidden mdUp implementation="css">
                                <Drawer
                                    container={container}
                                    variant="temporary"
                                    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                                    open={this.state.mobileOpen}
                                    onClose={this.handleDrawerToggle}
                                    classes={{
                                        paper: classes.drawerPaper,
                                    }}
                                    ModalProps={{
                                        keepMounted: true, // Better open performance on mobile.
                                    }}
                                >
                                    {drawer}
                                </Drawer>
                            </Hidden>
                            <Hidden mdDown implementation="css">
                                <Drawer
                                    classes={{
                                        paper: classes.drawerPaper,
                                    }}
                                    variant="permanent"
                                    open
                                >
                                    {drawer}
                                </Drawer>
                            </Hidden>
                        </nav>
                    ) : null
                }
            </div>
        );
    }
}

//is used to provide the route context to know what product is being displayed
ResponsiveDrawer.contextTypes = {
    router: PropTypes.object,
};

ResponsiveDrawer.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    width: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
};

export default withWidth()(withStyles(styles, { withTheme: true })(ResponsiveDrawer));
